import {useQuery} from 'react-query'
import {PostEditModalForm} from './PostEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getClassifiedPostById} from '../core/_requests'

const PostEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: post,
    error,
  } = useQuery(
    `${QUERIES.CLASSIFIED_POST_DETAILS}-${itemIdForUpdate}`,
    () => {
      return getClassifiedPostById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <PostEditModalForm isPostLoading={isLoading} post={{id: undefined}} />
  }

  if (!isLoading && !error && post) {
    return <PostEditModalForm isPostLoading={isLoading} post={post} />
  }

  return null
}

export {PostEditModalFormWrapper}

